import {Query} from 'react-apollo';
import React, {Fragment, Component} from 'react';
import styled from 'styled-components';

import {gqlGroupMap} from '../reports/reportGroups';
import Card from '../common/card-grid/Card';
import Error from '../settings/Error';
import FavoritePageIndicator from '../favorites/FavoritePageIndicator';
import Graph from '../graph/Graph';
import Loading from '../settings/Loading';
import NextPageButton from '../common/NextPageButton';
import PagingRouter from '../common/PagingRouter';
import ReportCardGrid from '../common/card-grid/ReportCardGrid';
import getPeriodAnchor from '../../utils/getPeriodAnchor';
import reportsQuery from './reportQuery';

const Wrapper = styled(Card)`
  margin: ${({theme}) => theme.spacingVertical()} 0;
  padding: initial;
`;

const reportsPerPage = 6;

export function ReportsResult({
  reports,
  hasNextPage,
  showNextPage,
  setActive,
  showSettings,
  active,
  isFavorite,
  onFavoriteClick,
  page,
  totalPages,
}) {
  function renderSinlgeGraph() {
    const report = reports[active];
    return (
      <Wrapper>
        <Graph
          details={true}
          setActive={() => setActive()}
          showLabels={true}
          showSettings={showSettings}
          isFavorite={isFavorite}
          onFavoriteClick={() => onFavoriteClick(report, active)}
          showDetailButton={reports.length !== 1}
          data={report}
        />
      </Wrapper>
    );
  }
  return (
    <Fragment>
      {typeof active === 'undefined' ? (
        <ReportCardGrid>
          {reports.map((report, i) =>{ 
            return (
            <Graph
              details={false}
              setActive={() => setActive(i)}
              showLabels={false}
              showDetailButton
              showSettings={showSettings}
              isFavorite={isFavorite}
              onFavoriteClick={() => onFavoriteClick(report, i)}
              key={i}
              data={report}
            />
          );})}
        </ReportCardGrid>
      ) : (
        renderSinlgeGraph()
      )}
      <NextPageButton hide={!hasNextPage} onClick={showNextPage} />
      {totalPages !== 1 && (
        <FavoritePageIndicator>
          Seite {page + 1} / {totalPages}
        </FavoritePageIndicator>
      )}
    </Fragment>
  );
}

//Todo: maybe also solve with paging
class ReportsResultWrapper extends Component {
  state = {active: undefined};

  setActive = i => this.setState({active: i});

  render() {
    const active = this.props.reports.length === 1 ? 0 : this.state.active;
    return <ReportsResult {...this.props} active={active} setActive={this.setActive} />;
  }
}

function ReportsResultPage({
  match: {
    params: {page},
  },
  getPageUrl,
  history,
  slug,
  totalPages,
}) {
  const pageNum = parseInt(page, 10);
  const periodAnchor = getPeriodAnchor();
  const input = {
    periodAnchor,
    filter: {group: gqlGroupMap[slug], offset: pageNum * reportsPerPage, limit: reportsPerPage},
  };
  return (
    <Query query={reportsQuery} variables={{input}}>
      {({loading, error, data}) => {
        if (loading) return <Loading />;
        if (error) return <Error error={error} />;
        const {reports, hasNextPage} = data.reports;
        return (
          <ReportsResultWrapper
            reports={reports}
            page={pageNum}
            totalPages={totalPages ? totalPages : 1}
            hasNextPage={pageNum !== 0 || hasNextPage}
            onFavoriteClick={({type}) => history.push(`/favorites/add/${type}/0`)}
            showNextPage={() => history.push(getPageUrl(hasNextPage ? pageNum + 1 : 0))}
          />
        );
      }}
    </Query>
  );
}

export default PagingRouter(ReportsResultPage);
